export default "__VITE_ASSET__d83c9471__"